import { axiosPrivate } from "@app/dashboard/tools/axios/axiosInstance";

export const roleRetrieve = (roleId:string) => {
  return axiosPrivate.get(`/dashboard/v1/roles/${roleId}`);
};